import 'alpinejs'

import $ from 'jquery'
import 'slick-carousel'

$( document ).ready(function() {
    console.log( "ready!" );
    const responsiveSettings = [
		{
			breakpoint: 980,
			settings: {
				slidesToShow:1,
				slidesToScroll:1,
			}
		}
	];
	$('.history-slider').slick({
		slidesToShow:2,
		slidesToScroll:2,
		arrows:false,
		asNavFor: '.history-slider__nav',
		responsive: responsiveSettings

	});

	$('.history-slider__nav').slick({
		slidesToShow: 2,
		slidesToScroll:2,
		asNavFor: '.history-slider',
		dots: true,
		focusOnSelect: true,
		responsive: responsiveSettings
	});
});